export class Utils {
  /**
   * get query param without router
   * @param key
   */
  static getQueryParameter(key: string): string {
    const parameters = new URLSearchParams(window.location.search);
    return parameters.get(key);
  }

  /**
   * get url segment without router
   * @param key
   */
  static getUrlSegment(key: string): string {
    const urlSegments = window.location.pathname.split( '/' );
    for (let index = urlSegments.length; index > 0 ; index--) {
      if (urlSegments[index] === key) {
        try {
          return urlSegments[index + 1];
        } catch (error) {
          return null;
        }
      }
    }
    return null;
  }
}
